import { useQueryClient } from 'react-query';

import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useRecruitmentsBulkUpdate = () => {
  const queryClient = useQueryClient();
  return usePost({
    url: ApiRoutesEnum.recruitmentsBulkUpdate,
    onSuccess: () => {
      queryClient.invalidateQueries({
        predicate: (query) => typeof query.queryKey[0] === 'string' && query.queryKey[0].includes('/recruitments'),
      });
    },
  });
};
